import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import styled from "styled-components";
import { WalletOutlined, BarChartOutlined, SettingOutlined } from "@ant-design/icons";

// 導覽列本體滿版（背景與底線），內容對齊頁面的置中容器
const NavShell = styled.nav`
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
`;

const NavInner = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 0 1em;
`;

export default function NavBar() {
  const { pathname } = useLocation();
  let selectedKey = "/";
  if (pathname.startsWith("/analytics")) {
    selectedKey = "/analytics";
  } else if (pathname.startsWith("/settings")) {
    selectedKey = "/settings";
  }

  const items = [
    { key: "/", icon: <WalletOutlined />, label: <Link to="/">花費紀錄</Link> },
    { key: "/analytics", icon: <BarChartOutlined />, label: <Link to="/analytics">分析</Link> },
    { key: "/settings", icon: <SettingOutlined />, label: <Link to="/settings">設定</Link> },
  ];

  return (
    <NavShell>
      <NavInner>
        <Menu
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={items}
          style={{ borderBottom: "none" }}
        />
      </NavInner>
    </NavShell>
  );
}
